/*
 * @Author: Jiajia Li
 * @Date: 2024-08-28 20:30:04
 * @LastEditTime: 2024-08-28 22:08:35
 * @Description:
 */

import React from "react";
import "./Spinner.css";

export default function Spinner() {
  return (
    <div className="spinner-container">
      <div className="spinner-border spinner-colorful" role="status"></div>
      <span className="spinner-text">Loading...</span>
    </div>
  );
}
